import videojs from 'video.js';
const registerPlugin = videojs.registerPlugin || videojs.plugin;

const seek_locker = function(options) {
  const max_seek = Math.round(options.max_seek * 1);
	if (!max_seek || max_seek < 0) return;
	this.ready(() => {
    this.on('seeking', () => {
      let duration = this.duration();
      // При воспроивзедении видео на iOS-устройствах не используется плагин hls.js. Из-за этого
      // длительность live-трансляций будет иметь значение бесконечность
      // (https://html.spec.whatwg.org/multipage/media.html):
      //    > If the media resource is not known to be bounded (e.g. streaming radio, or a live
      //    > event with no announced end time), then the attribute must return the positive
      //    > Infinity value.
      if (duration === Infinity) {
        // Определяем длительность транлсяции самостоятельно, с помощью атрибута seekable, в котором
        // имеются данные о временных границах, доступных для осуществления сика
        // (https://html.spec.whatwg.org/multipage/media.html#dom-media-seekable)
        duration = this.tech_.el_.seekable.end(this.tech_.el_.seekable.length - 1);
      }

      // Округляем длительность в меньшую сторону, чтобы при расчетах не оказаться дальше, чем это
      // возможно
      duration = Math.floor(duration);

      // Вычисляем разницу между длительностью трансляции и осуществлемым перемещением на таймлайне.
      // Если разница выше порогового значения max_seek, то позволяем переместиться на max_seek
      // секунд назад от текущей длительности трансляции, иначе - разрешаем переместиться туда, куда
      // желалось
      if (duration - this.currentTime() > max_seek) {
        // К допустимому времени сика добавляем единицу и выполняем округление в большую сторону,
        // чтобы избежать возникновения на iOS-устройствах бесконечного цикла обработки события
        // seeking
        let seek = Math.ceil(duration - max_seek  + 1);
        this.currentTime(seek);
      }
    });
	});
};

registerPlugin('seek_locker', seek_locker);

export default seek_locker;
